import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Loader2, ArrowLeft, MapPin, UserPlus, CheckCircle2, Send, Trophy, Zap } from "lucide-react";
import api from "../lib/apiClient";
import { toast } from "sonner";

// Fiche PUBLIQUE d'un artiste découvrable (aucune donnée privée). Invitation réutilise le flux existant.
export default function ManagerArtistPublic() {
  const { id } = useParams();
  const nav = useNavigate();
  const [a, setA] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/manager/discover/${id}`).then((r) => setA(r.data)).catch(() => setNotFound(true));
  }, [id]);

  const invite = async () => {
    try { await api.post(`/manager/discover/${id}/invite`); toast.success("Invitation envoyée"); setA((x) => ({ ...x, state: "INVITED" })); }
    catch (e) { toast.error(e.response?.data?.detail || "Échec de l'invitation"); }
  };

  if (notFound) return (
    <div className="text-center py-20" data-testid="artist-public-notfound">
      <p className="text-zinc-300">Profil indisponible ou non ouvert au management.</p>
      <button onClick={() => nav("/manager/discover")} className="mt-3 text-sm text-amber-400">Retour à la découverte</button>
    </div>
  );
  if (!a) return <div className="flex justify-center py-20"><Loader2 className="w-7 h-7 text-amber-500 animate-spin" /></div>;

  return (
    <div className="space-y-6 max-w-2xl" data-testid="artist-public-page">
      <button onClick={() => nav("/manager/discover")} className="inline-flex items-center gap-1.5 text-sm text-zinc-400 hover:text-zinc-200"><ArrowLeft className="w-4 h-4" />Retour</button>
      <div className="bg-[#18181E] border border-zinc-800 rounded-3xl p-6">
        <div className="flex items-center gap-4">
          <div className="w-20 h-20 rounded-2xl bg-zinc-800 overflow-hidden shrink-0">
            {a.avatar_url && <img src={a.avatar_url} alt="" className="w-full h-full object-cover" />}
          </div>
          <div className="min-w-0">
            <h1 className="font-display text-2xl font-extrabold truncate">{a.artist_name}</h1>
            <p className="text-sm text-zinc-500">{a.domain || "Artiste"}{a.city ? ` · ${a.city}` : ""}</p>
            <div className="flex gap-3 mt-2 text-xs">
              <span className="inline-flex items-center gap-1 text-amber-400"><Trophy className="w-3.5 h-3.5" />Niveau {a.level}</span>
              <span className="inline-flex items-center gap-1 text-zinc-400"><Zap className="w-3.5 h-3.5" />{a.xp} XP</span>
            </div>
          </div>
        </div>
        {a.bio && <p className="text-sm text-zinc-300 mt-4">{a.bio}</p>}
        {(a.goals || []).length > 0 && (
          <div className="mt-4"><p className="text-xs font-mono uppercase tracking-wider text-zinc-500 mb-1.5">Objectifs</p>
            <div className="flex flex-wrap gap-1.5">{a.goals.map((g) => <span key={g} className="text-[11px] px-2 py-0.5 rounded-full bg-zinc-800 text-zinc-300">{g}</span>)}</div></div>
        )}
        {(a.genres || []).length > 0 && (
          <div className="mt-4"><p className="text-xs font-mono uppercase tracking-wider text-zinc-500 mb-1.5">Genres</p>
            <div className="flex flex-wrap gap-1.5">{a.genres.map((g) => <span key={g} className="text-[11px] px-2 py-0.5 rounded-full bg-zinc-800 text-zinc-300">{g}</span>)}
              {a.country && <span className="text-[11px] px-2 py-0.5 rounded-full bg-zinc-800 text-zinc-400 inline-flex items-center gap-1"><MapPin className="w-3 h-3" />{a.country}</span>}</div></div>
        )}
        <div className="mt-6">
          {a.state === "MANAGED" ? (
            <span className="text-sm text-emerald-400 inline-flex items-center gap-1.5"><CheckCircle2 className="w-4 h-4" />Déjà dans ton équipe</span>
          ) : a.state === "INVITED" ? (
            <span className="text-sm text-amber-400 inline-flex items-center gap-1.5" data-testid="artist-public-invited"><Send className="w-4 h-4" />Invitation en attente</span>
          ) : (
            <button onClick={invite} data-testid="artist-public-invite" className="inline-flex items-center gap-1.5 h-11 px-5 rounded-xl gold-gradient text-black font-semibold text-sm"><UserPlus className="w-4 h-4" />Inviter à rejoindre mon équipe</button>
          )}
        </div>
      </div>
    </div>
  );
}
